<template>
  <div class="inline-block mr-6">
    <fa :icon="getIcon" />
    <span
      class="ml-2"
      :data-i18n="`hotelFacility.${facility}`"
    >{{ $t(`hotelFacility.${facility}`) }}</span>
  </div>
</template>

<script>
import {
  faBaseballBall,
  faBeer,
  faWifi,
  faSwimmingPool,
  faDumbbell,
  faGolfBall,
  faConciergeBell,
  faGamepad,
  faChild,
  faUtensils,
  faBicycle,
  faRunning,
  faBaseball,
  faTableTennis,
  faMale,
  faDice,
  faGolfClub,
  faSkiing,
  faSpa,
  faRacquet,
  faHotTub,
  faForkKnife,
} from '@fortawesome/pro-duotone-svg-icons'

const faIcons = {
  faBaseballBall,
  faBeer,
  faWifi,
  faSwimmingPool,
  faDumbbell,
  faGolfBall,
  faConciergeBell,
  faGamepad,
  faChild,
  faUtensils,
  faBicycle,
  faRunning,
  faBaseball,
  faTableTennis,
  faMale,
  faDice,
  faGolfClub,
  faSkiing,
  faSpa,
  faRacquet,
  faHotTub,
  faForkKnife,
}

export default defineNuxtComponent({
  props: {
    facility: {
      type: String,
      required: true,
    },
  },

  computed: {
    getIcon () {
      const iconClass = 'fa' + this.facility.split('-').map(s => s.charAt(0).toUpperCase() + s.slice(1)).join('')
      return faIcons[iconClass] || ['fad', this.facility]
    },
  },
})
</script>
